import React, { FC, useState } from 'react';
import { Button, Radio, Space } from 'antd';
import styles from './Filters.module.less';
import { useSearchContext } from '../../SearchContext';
import { FilterTitle } from './FilterTitle';

type Props = {
  value?: string;
  onChange?: (value?: string) => void;
  onCancel?: () => void;
};

export const PostedDateSelector: FC<Props> = (props) => {
  const { onChange } = props;
  const [value, setValue] = useState<string | undefined>(props.value);
  const ctx = useSearchContext();

  return (
    <Space direction="vertical" size={16} className={styles.filterArea}>
      <FilterTitle
        id={'posted-date-filter'}
        title={'Posted Date'}
        onApply={() => onChange?.(value && value.length > 0 ? value : undefined)}
        onCancel={props.onCancel}
      />
      <Radio.Group
        onChange={(e) => setValue(e.target.value === 'Any' ? undefined : e.target.value)}
        value={value ?? 'Any'}>
        <Space direction="vertical">
          {['Any', 'Last 24 Hours', 'Last Week', 'Last Month'].map((v) => (
            <Radio key={v} value={v}>
              {v} ({ctx.results?.aggs?.posted?.[v]})
            </Radio>
          ))}
        </Space>
      </Radio.Group>
      <Button
        className={styles.applyButton}
        type={'primary'}
        size={'small'}
        onClick={() => onChange?.(value && value.length > 0 ? value : undefined)}>
        Apply
      </Button>
    </Space>
  );
};
